import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './KanbanConfirmModal.module.scss';

export interface KanbanConfirmModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  children: React.ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  cancelLabel?: string;
  variant?: 'default' | 'danger';
  confirmDisabled?: boolean;
}

export default function KanbanConfirmModal({
  show,
  onHide,
  title,
  children,
  confirmLabel,
  onConfirm,
  cancelLabel = 'Cancel',
  variant = 'default',
  confirmDisabled = false,
}: KanbanConfirmModalProps) {
  const confirmClassName =
    variant === 'danger'
      ? `${styles.confirmBtn} ${styles.confirmBtnPrimary} ${styles.confirmBtnDanger}`
      : `${styles.confirmBtn} ${styles.confirmBtnPrimary}`;

  return (
    <Modal show={show} onHide={onHide} centered className={styles.confirmModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className={`${styles.confirmBtn} ${styles.confirmBtnSecondary}`}
          onClick={onHide}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className={confirmClassName}
          onClick={() => onConfirm()}
          disabled={confirmDisabled}
        >
          {confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
